import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import {
  KeyboardArrowLeft,
} from '@material-ui/icons';
import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import {
  RouteComponentProps, withRouter,
} from 'react-router';
import * as Yup from 'yup';
import {
  FormField,
} from '../../components/GeneralCRUDComponent/FormFields/formFields';
import GeneralFormComponent from '../../components/GeneralCRUDComponent/GeneralFormComponent/GeneralFormComponent';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import Spinner from '../../components/Spinner';
import {
  countriesIsoCodes,
} from '../../constants/countries';
import {
  DefaultLanguage, getDropdownLanguagesList, languageCodes,
} from '../../constants/languages';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  ICountry,
} from '../../mobx-store/storeInterfaces/authInterface';
import {
  IBranchStore,
} from '../../mobx-store/storeInterfaces/branchInterface';
import {
  IRestaurantStore,
} from '../../mobx-store/storeInterfaces/restaurantInterface';
import {
  CountryStore,
} from '../../mobx-store/stores/countryStore';
import classes from './addEditRestaurant.module.scss';

interface IProps extends WithSnackbarProps {
  restaurantStore: IRestaurantStore;
  branchStore: IBranchStore;
  countryStore: CountryStore;
  match: any;
  history: any;
}

interface IState {
  formFields: FormField[];
  loadingRestaurant: boolean;
  loadingManagedCountries: boolean;
  loadingBranches: boolean;
  processing: boolean;
  selectedLang: string;
}

@inject('restaurantStore')
@inject('countryStore')
@inject('branchStore')
@observer
class AddEditRestaurant extends Component<IProps & RouteComponentProps, IState> {
  isNew = false;

  isEgypt = false;

  restaurantId = -1;

  pageTitle = '';

  restaurantFormTitle = '';

  restaurantSchema: any;

  submitButton: any;

  lastHistory = -1;

  cancelButton: any;

  initGallery: {imageUrl: string; key: number} [] = [];

  dropdownLanguages: {
    langList: { langCode: string; langValue: string } [];
    selectedLang: string;
    label: string;
    onChange(langCode: string): any;
  } | null = null;

  constructor(props: IProps & RouteComponentProps) {
    super(props);
    this.initializeComponent(props);
  }

  initializeComponent(props: IProps & RouteComponentProps, isConstructor = true) {
    if (props.match.params.id) {
      this.isNew = false;
      this.restaurantId = props.match.params.id;
      this.pageTitle = translate('editRestaurantPageTitle', {
      });
    } else {
      this.isNew = true;
      this.pageTitle = translate('addRestaurantPageTitle', {
      });
    }
    this.initRestaurantSchema();
    this.initState(isConstructor);
    this.submitButton = this.getSubmitButton();
    this.cancelButton = this.getCancelButton();
    this.restaurantFormTitle = translate('addRestaurantPageFormTitle', {
    });
    this.dropdownLanguages = this.getDropdownLanguages();
  }

  getDropdownLanguages = () => {
    if (this.isNew) {
      return null;
    }
    return {
      langList: getDropdownLanguagesList(),
      selectedLang: this.state.selectedLang,
      label: 'Select Languages',
      onChange: this.handelLanguageChange,
    };
  };

  handelLanguageChange = async (langCode: string) => {
    if (this.isNew) {
      this.setState({
        selectedLang: langCode,
      });
    } else {
      await this.getRestaurant(langCode);
    }
  };

  initRestaurantSchema = () => {
    this.restaurantSchema = Yup.object().shape({
      title: Yup.string()
        .required('Required'),
      description: Yup.string()
        .required('Required'),
      images: Yup.array(),
      logo: Yup.array()
        .min(1, 'Need logo image')
        .required('Required'),
    });
  };

  async componentWillReceiveProps(nextProps: IProps & RouteComponentProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.lastHistory = -2;
      this.initializeComponent(nextProps, false);
      this.setState({
        loadingManagedCountries: false,
      });
      this.forceUpdate();
      await this.getBranches();
      if (!this.isNew) {
        await this.getRestaurant(languageCodes.english);
      }
    }
  }

  initState = (isConstructor = true) => {
    const initState: IState = {
      selectedLang: this.isEgypt ? languageCodes.arabic : languageCodes.english,
      processing: false,
      loadingManagedCountries: false,
      loadingRestaurant: !this.isNew,
      loadingBranches: true,
      formFields: [
        {
          name: 'title',
          label: this.isNew && this.isEgypt ? translate('addRestaurantPageFormArabicTitle', {
          }) : translate('addRestaurantPageFormEnglishTitle', {
          }),
          type: 'text',
          filedType: 'InputField',
        },
        {
          name: 'description',
          label: this.isNew && this.isEgypt ? translate('addRestaurantPageFormArabicDescription', {
          }) : translate('addRestaurantPageFormEnglishDescription', {
          }),
          type: 'text',
          multiLine: true,
          rowsMax: 3,
          filedType: 'InputField',
        },
        {
          name: 'availableBranches',
          label: translate('addRestaurantPageFormAvailableBranches', {
          }),
          selectList: [],
          selectListValue: 'title',
          selectListKey: 'id',
          filedType: 'MultipleSelectField',
        },
        {
          name: 'logo',
          label: translate('addRestaurantPageFormLogo', {
          }),
          filedType: 'GalleryField',
          isLimitToOneImage: true,
          accept: 'image/*',
          size: 200,
        },
        {
          name: 'images',
          label: translate('addRestaurantPageFormImages', {
          }),
          filedType: 'GalleryField',
          accept: 'image/*',
          size: 200,
        },
      ],
    };
    if (isConstructor) {
      this.state = initState;
    } else {
      this.setState(initState);
    }
  };

  handelSubmit = (values: any): void => {
    const {
      countryStore,
    } = this.props;
    values.availableCountries = countryStore.managedCountries.map((country: ICountry) => country.isoCode);

    this.setState({
      processing: true,
    });
    if (this.isNew) {
      try {
        this.props.restaurantStore.createRestaurant(values, this.state.selectedLang)
          .then((restaurantId) => {
            if (this.isEgypt) {
              this.props.history.push(`${restaurantId}/edit`);
            } else {
              this.props.history.go(this.lastHistory);
            }
            SnackBarComponent.getInstance().openSnackbar(translate('createdMessage', {
            }), 5000, 'success');
          });
      } catch {
        this.setState({
          processing: false,
        });
        SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
        }), 5000, 'error');
      }
    } else {
      this.props.restaurantStore.updateRestaurant(values, this.restaurantId, this.initGallery, this.state.selectedLang)
        .then(() => {
          SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
          }), 5000, 'success');
          this.props.history.go(this.lastHistory);
        }).catch((error) => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
          }), 5000, 'error');
        });
    }
  };

  handelCancel = (): void => {
    this.props.history.goBack();
  };

  getSubmitButton = () => ({
    title: (this.isNew && this.isEgypt ? 'To Next Language' : 'Save Changes'),
    onSubmit: this.handelSubmit,
  });

  getCancelButton = () => ({
    title: 'Cancel',
    onCancel: this.handelCancel,
  });

  updateStateWithRestaurantData = () => {
    const formFieldsWithData = [];
    for (const field of this.state.formFields) {
      formFieldsWithData.push({
        ...field, value: this.props.restaurantStore.selectedRestaurant[field.name],
      });
    }
    this.initGallery = Object.assign([], this.props.restaurantStore.selectedRestaurant.images);
    this.setState({
      formFields: formFieldsWithData, loadingRestaurant: false,
    });
  };

  updateStateWithBranchesData = () => {
    const formFieldsWithData = [];
    for (const field of this.state.formFields) {
      if (field.name === 'availableBranches') {
        formFieldsWithData.push(
          {
            ...field, selectList: this.props.branchStore.branchesList,
          },
        );
      } else {
        formFieldsWithData.push(field);
      }
    }
    this.setState({
      formFields: formFieldsWithData, loadingBranches: false,
    });
  };

  render() {
    return (
      <div className={classes.container}>
        <div className={classes.header}>
          <IconButton
            className={classes.backButton}
            onClick={() => this.props.history.goBack()}
            aria-label="Back"
          >
            <KeyboardArrowLeft />
          </IconButton>
          <Typography className={classes.title} variant="h6" gutterBottom>
            {this.pageTitle}
          </Typography>
        </div>
        <div className={classes.content}>
          {
            this.state.loadingRestaurant || this.state.loadingBranches || this.state.loadingManagedCountries
              ? <Spinner />
              : (
                <GeneralFormComponent
                  formTitle={this.restaurantFormTitle}
                  fields={this.state.formFields}
                  formSchema={this.restaurantSchema}
                  submitButton={this.submitButton}
                  cancelButton={this.cancelButton}
                  processing={this.state.processing}
                  dropdownLanguages={this.isEgypt ? this.dropdownLanguages : null}
                />
              )
          }
        </div>
      </div>
    );
  }

  async componentDidMount() {
    const {
      countryStore,
      restaurantStore,
      branchStore,
    } = this.props;
    await countryStore.getUserManagedCountries();

    if (countryStore.managedCountries.some((country: ICountry) => country.isoCode === countriesIsoCodes.egypt)) {
      this.isEgypt = true;
    }
    this.initState(false);
    this.submitButton = this.getSubmitButton();
    await this.getBranches();
    if (!this.isNew) {
      await this.getRestaurant(languageCodes.english);
    }
    this.setState({
      loadingManagedCountries: false,
    });
  }

  getRestaurant = async (langCode: string) => {
    this.setState({
      loadingRestaurant: true,
    });
    await this.props.restaurantStore.getRestaurantById(this.restaurantId, langCode);
    this.updateStateWithRestaurantData();
    this.dropdownLanguages!.selectedLang = langCode;
    this.setState({
      selectedLang: langCode, loadingRestaurant: false,
    });
  };

  getBranches = async () => {
    this.setState({
      loadingBranches: true,
    });
    await this.props.branchStore.getBranches(this.props.countryStore.managedCountries, DefaultLanguage);
    this.updateStateWithBranchesData();
    this.setState({
      loadingBranches: false,
    });
  };
}

export default withRouter(AddEditRestaurant);
